import { createFileRoute } from '@tanstack/react-router'
import PageNotFound from '@/common/components/views/PageNotFound'

export const Route = createFileRoute('/app/demos/sets/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <PageNotFound />
}
